export class Connection {
    private id: string;
    private color: string;

    constructor( id: string, color: string) {
        this.id = id;
        this.color = color;
    }

    public setId (id: string) { this.id = id; }
    public getId () { return this.id; }
    
    public setColor (color: string) { this.color = color; }
    public getColor () { return this.color; }
    
    public searchForId (idSearched: string) {
        if (idSearched == this.id) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/Connection.component.ts